import React from 'react';

const TenantUsagePanel = ({ usage }) => {
  const cards = [
    { label: 'Monitored Customers', value: usage?.monitoredCustomers || 0 },
    { label: 'Incidents Processed', value: usage?.incidentsProcessed || 0 },
    { label: 'API Usage', value: usage?.apiUsage || 0 },
    { label: 'Recovery Executions', value: usage?.recoveryExecutions || 0 },
    { label: 'Batch Actions Used', value: usage?.batchActionsUsed || 0 },
  ];

  return (
    <section className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
      <h3 className="text-sm font-semibold text-slate-100">Penggunaan Tenant</h3>
      <div className="mt-3 grid gap-2 md:grid-cols-2 xl:grid-cols-5">
        {cards.map((card) => (
          <div key={card.label} className="rounded-lg border border-slate-800 bg-slate-950/60 px-3 py-2 text-xs text-slate-300">
            <div className="text-slate-400">{card.label}</div>
            <div className="mt-1 text-lg font-semibold text-slate-100">{card.value}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TenantUsagePanel;
